import styled from "styled-components"

export const CarouselImg = styled.div`
    background-image: url(${({src}) => src || ""});
    background-repeat: no-repeat;
    background-position: ${({bgPosition}) => bgPosition || "center"};
    background-size: cover;
    min-height: ${({height}) => height || "65vh"};
    display: flex;
    flex-direction: column;
    justify-content:  center;
    transition:all ease .2s;
    @media (max-width: 575px) {
        min-height: 70vh;
        background-image: url(${({src}) => src.replace("desktop", "mobile") || ""});
        align-items: flex-end;
    }
`
export const CarouselContent = styled.div`
    color: #fff;
    text-align: center;
`

export const DotIndicatorWrapper = styled.div` 
    width: 100%;
`
export const DotIndicator = styled.div`
    &:hover{
        opacity: 1;
        background-color: #e20074;
    }
    height: 10px;
    width: 10px;
    height: ${({active}) => active ? "10px" : "9px"};
    width: ${({active}) => active ? "10px" : "9px"};
    background-color: #e20074;
    border-radius: 50%;
    display: inline-block;
    border: solid 1px #e20074;
    background-color: ${({active}) => active ? "#e20074" : "#fff"};
    cursor:pointer;
    transition:all ease .2s;
`


